import { useEventCallback } from '@mui/material';
import ActionsList from 'front-office/components/reprint-cid/actions-list';
import { ReprintCidSearchPersonCrubs } from 'front-office/constants/reprint-cid-crubs';
import { Fragment, useState } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { PersonVM } from 'shell/view-models/search-person';
import ModalWarning from '../modal-error';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';

const ReprintCidSearchPerson = (): React.ReactElement => {
  const { userProfile } = useUserProfile();
  const authorizationNationalSearch = userProfile.datiLogin?.profile?.feature?.anpr;
  const isNationalSearch = authorizationNationalSearch === '2';

  const [open, setOpen] = useState({
    open: false,
    warning: '',
    person: {} as PersonVM,
    isNationalResearch: 'false',
  });

  const setWarning = useEventCallback(
    (warning?: string, person?: PersonVM, isNationalResearch?: string) => {
      setOpen({
        open: true,
        warning: warning || '',
        person: person || ({} as PersonVM),
        isNationalResearch: isNationalResearch || 'false',
      });
    }
  );

  const navigate = useNavigate();

  const onSi = useEventCallback(() => {
    navigate({
      pathname: '/sportello/ristampa-carta/ricerca-persona/ristampa',
      search: `?${createSearchParams({
        ricercaNazionale: open.isNationalResearch,
        codiceFiscale: open.person?.fiscalCode || '',
        idSchedaSoggettoANPR: open.person?.anpr || '',
        idFamigliaANPR: open.person?.idFamilyAnpr || '',
        idSchedaSoggettoComune: open.person?.idSchedaSoggettoComune?.idSchedaSoggetto || '',
        nome: open.person?.name || '',
        cognome: open.person?.surname || '',
        stato: open.person?.statePerson || '',
      })}`,
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={ReprintCidSearchPersonCrubs} />
      <PersonSearch
        addedTitle="- Stampa busta CIE"
        pathname="/sportello/ristampa-carta/ricerca-persona/ristampa"
        url={`${__PERSON_NEW_API_URL__}/ricerca-persona/ristampa-carta`}
        action={ActionsList}
        isNationalSearch={isNationalSearch}
        isRistampaBusta
        setWarning={setWarning}
      />
      {open.open ? (
        <ModalWarning
          open={open.open}
          onClose={() => {
            setOpen({
              open: false,
              warning: '',
              person: {} as PersonVM,
              isNationalResearch: 'false',
            });
          }}
          message={open.warning}
          onConfirm={onSi}
        />
      ) : undefined}
    </Fragment>
  );
};

ReprintCidSearchPerson.displayName = 'Reprint Cid Search Person page component';

export default ReprintCidSearchPerson;
